var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 7.75L9.75 0.75L0.75 9.75H2.75V16.75C2.75 17.2804 2.96071 17.7891 3.33579 18.1642C3.71086 18.5393 4.21957 18.75 4.75 18.75H10.75M6.75 18.75V12.75C6.75 12.2196 6.96071 11.7109 7.33579 11.3358C7.71086 10.9607 8.21957 10.75 8.75 10.75H10.75C11.137 10.75 11.498 10.86 11.804 11.05M18.75 12.75H16.25C15.8522 12.75 15.4706 12.908 15.1893 13.1893C14.908 13.4706 14.75 13.8522 14.75 14.25C14.75 14.6478 14.908 15.0294 15.1893 15.3107C15.4706 15.592 15.8522 15.75 16.25 15.75H17.25C17.6478 15.75 18.0294 15.908 18.3107 16.1893C18.592 16.4706 18.75 16.8522 18.75 17.25C18.75 17.6478 18.592 18.0294 18.3107 18.3107C18.0294 18.592 17.6478 18.75 17.25 18.75H14.75M16.75 18.75V19.75M16.75 11.75V12.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncHome);
export default __webpack_public_path__ + "static/media/icon_inc_home.3e73e35ac5100517e5b6c1017ebec2bd.svg";
export { ForwardRef as ReactComponent };